<script setup lang="ts">
import { withTrailingSlash } from 'ufo'

const props = defineProps({
  tags: {
    type: Array as () => string[],
    default: null,
  },
  path: {
    type: String,
    default: null,
  },
})

const tagBase = '/tag/'

const { data: tagPages } = await useAsyncData(
  `tags-directory-${props.path ?? 'none'}`,
  async () => {
    if (!props.path) return []
    const base = withTrailingSlash(props.path)
    return queryContent(base).sort({ title: 1 }).find()
  },
)
</script>

<template>
  <div
    v-if="path && tagPages?.length"
    class="flex flex-wrap justify-center gap-3 sm:px-0 px-4"
  >
    <NuxtLink
      v-for="doc in tagPages"
      :key="doc._path"
      :to="doc._path"
      class="px-3 py-1 rounded bg-gray-200 dark:bg-gray-800 text-sm font-semibold text-gray-800 dark:text-gray-100 hover:bg-primary-100 dark:hover:bg-primary-900/40 transition-colors"
    >
      {{ doc.title || doc._path }}
    </NuxtLink>
  </div>

  <ul
    v-else-if="tags?.length"
    class="m-0 flex list-none flex-wrap gap-2 p-0"
  >
    <li
      v-for="tag of tags"
      :key="tag"
    >
      <NuxtLink
        :to="`${tagBase}${encodeURIComponent(tag)}/`"
      >
        <span class="px-2 py-0.5 rounded text-xs font-bold bg-black/30 text-white">
          {{ tag.charAt(0).toUpperCase() + tag.slice(1) }}
        </span>
      </NuxtLink>
    </li>
  </ul>
</template>
